module.exports = __webpack_public_path__ + "img/tutorial8.848d4e54.png";